import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { SkeletonContainer } from 'ui/skeleton';
import { colors, spacing, smallShadow } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p40: pxToRem(40),
};

type StyledSkeletonContainerType = {
  height: string | number;
};

export const CardWrapper = styled.div`
  background: ${colors.white};
  ${smallShadow};
  border-radius: ${spacing.half};
  margin-bottom: ${customSpacing.p40};
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
  background: ${colors.grey15};
`;

export const StyledSkeletonContainer = styled(SkeletonContainer)<StyledSkeletonContainerType>`
  display: flex;
  height: ${({ height }) => (typeof height === 'number' ? pxToRem(height) : height)};
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: ${spacing.half};
  border-bottom-left-radius: ${spacing.half};
`;

export const CardContent = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
